import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { UnitType } from '../../../../../models/enums/unit-type.enum';
import { MeasurementService } from '../../../../../services/measurement.service';

@Component({
    selector: 'app-min-gasket-stress',
    templateUrl: './min-gasket-stress.component.html',
    styleUrls: ['./min-gasket-stress.component.scss'],
})
export class MinGasketStressComponent implements OnInit {
    @Input() form: UntypedFormGroup;
    tooltip_position = 'above';

    constructor(private measSvc: MeasurementService) {}

    ngOnInit(): void {
        this.form
            .get('minGasketStress')
            .valueChanges.subscribe((value) =>
                this.form.get('minGasketStress').patchValue(this.measSvc.format(value, UnitType.DefaultStressUnit), { emitEvent: false })
            );
    }
}
